import { http } from '../index'

// 学员相关接口类型定义
export interface Student {
  id: number
  student_no: string
  name: string
  phone?: string
  wechat?: string
  gender: number
  gender_text: string
  id_card?: string
  avatar?: string
  store_id?: number
  sales_admin_id?: number
  service_admin_id?: number
  source?: string
  intended_course?: string
  purpose: number
  purpose_text: string
  address?: string
  has_certificate: number
  has_certificate_text: string
  remark?: string
  internal_remark?: string
  status: number
  status_text: string
  enrollment_date?: string
  graduation_date?: string
  store?: {
    id: number
    name: string
  }
  sales_admin?: {
    id: number
    name: string
  }
  service_admin?: {
    id: number
    name: string
  }
  creator?: {
    id: number
    name: string
  }
  created_at: string
  updated_at: string
}

export interface StudentListParams {
  page?: number
  per_page?: number
  keyword?: string
  store_id?: number
  sales_admin_id?: number
  service_admin_id?: number
  status?: number
  gender?: number
  purpose?: number
  has_certificate?: number
  source?: string
  intended_course?: string
  enrollment_start_date?: string
  enrollment_end_date?: string
  created_start_date?: string
  created_end_date?: string
  sort_field?: string
  sort_order?: string
}

export interface StudentCreateData {
  name: string
  phone?: string
  wechat?: string
  gender: number
  id_card?: string
  store_id?: number
  sales_admin_id?: number
  service_admin_id?: number
  source?: string
  intended_course?: string
  purpose: number
  address?: string
  has_certificate: number
  remark?: string
  internal_remark?: string
  status?: number
  enrollment_date?: string
  graduation_date?: string
}

export interface StudentUpdateData extends Partial<StudentCreateData> {}

export interface StudentBatchData {
  ids: number[]
  operation: 'delete' | 'update_status' | 'assign_sales' | 'assign_service'
  status?: number
  sales_admin_id?: number
  service_admin_id?: number
}

export interface StudentStatistics {
  total: number
  normal: number
  suspended: number
  graduated: number
  dropout: number
  male: number
  female: number
  purpose_job: number
  purpose_training: number
  has_certificate: number
  no_certificate: number
}

// 学员API
export const studentApi = {
  // 获取学员列表
  list: (params: StudentListParams = {}) => {
    return http.get('/admin/students', { params })
  },

  // 创建学员
  create: (data: StudentCreateData) => {
    return http.post('/admin/students', data)
  },

  // 获取学员详情
  detail: (id: number) => {
    return http.get(`/admin/students/${id}`)
  },

  // 更新学员
  update: (id: number, data: StudentUpdateData) => {
    return http.put(`/admin/students/${id}`, data)
  },

  // 删除学员
  delete: (id: number) => {
    return http.delete(`/admin/students/${id}`)
  },

  // 更新学员状态
  updateStatus: (id: number, status: number) => {
    return http.patch(`/admin/students/${id}/status`, { status })
  },

  // 批量操作
  batch: (data: StudentBatchData) => {
    return http.post('/admin/students/batch', data)
  },

  // 获取统计数据
  statistics: (params: StudentListParams = {}) => {
    return http.get('/admin/students/statistics/overview', { params })
  },

  // 获取分布统计
  distribution: (params: StudentListParams = {}) => {
    return http.get('/admin/students/statistics/distribution', { params })
  },

  // 导出数据
  export: (params: StudentListParams = {}) => {
    return http.post('/admin/students/export', params)
  },
}
